export const heroSlides = [
  {
    id: 1,
    category: "أخبار السياحة",
    title: "دبي تتصدر قائمة أكثر الوجهات السياحية زيارةً في 2026",
    description: "تقرير جديد يكشف أن الإمارة الذهبية استقبلت أكثر من 22 مليون سائح خلال الربع الأول من عام 2026، متجاوزةً توقعات المنظمة العالمية للسياحة",
    image: "https://readdy.ai/api/search-image?query=Dubai%20skyline%20at%20golden%20sunset%20with%20Burj%20Khalifa%20reflecting%20in%20water%2C%20aerial%20view%20of%20the%20city%20showing%20tourism%20and%20urban%20development%2C%20wide%20angle%20photography%20warm%20colors&width=1920&height=1080&seq=hero1&orientation=landscape",
    readTime: "5 دقائق",
    date: "22 أبريل 2026",
    author: "أحمد الزهراني",
    views: "47,200",
    tag: "عاجل",
  },
  {
    id: 2,
    category: "أخبار المطارات",
    title: "مطار الرياض الدولي الجديد يستعد للافتتاح الرسمي في سبتمبر 2026",
    description: "مطار الملك سلمان الدولي سيصبح الأكبر في العالم بطاقة استيعابية تبلغ 185 مليون مسافر سنوياً، ويشكل قفزة نوعية لقطاع الطيران السعودي",
    image: "https://readdy.ai/api/search-image?query=Riyadh%20new%20international%20airport%20futuristic%20terminal%20architecture%20Saudi%20Arabia%20aviation%20news%202026%2C%20modern%20airport%20interior%20with%20daylight&width=1920&height=1080&seq=hero2&orientation=landscape",
    readTime: "7 دقائق",
    date: "21 أبريل 2026",
    author: "سارة المطيري",
    views: "38,500",
    tag: "حصري",
  },
  {
    id: 3,
    category: "السياحة الثقافية",
    title: "اليونسكو تُدرج موقع العُلا السعودي على قائمة التراث الإنساني",
    description: "قرار تاريخي يُعزز مكانة المملكة العربية السعودية على خريطة السياحة الثقافية العالمية، ويُتيح لموقع الحِجر تسليطَ الضوء الدولي الذي يستحقه",
    image: "https://readdy.ai/api/search-image?query=AlUla%20Saudi%20Arabia%20ancient%20Nabataean%20rock%20formations%20Hegra%20Madain%20Saleh%20archaeological%20site%20UNESCO%20heritage%20golden%20hour%20desert%20photography&width=1920&height=1080&seq=hero3&orientation=landscape",
    readTime: "4 دقائق",
    date: "20 أبريل 2026",
    author: "فيصل الدوسري",
    views: "29,800",
    tag: "تقارير",
  },
  {
    id: 4,
    category: "أخبار الطيران",
    title: "طيران الخليج يُطلق أول رحلة مباشرة بين المنامة وطوكيو",
    description: "شركة طيران الخليج تُوسّع شبكة رحلاتها عبر إضافة خط مباشر بين البحرين والعاصمة اليابانية طوكيو ضمن استراتيجية التوسع الآسيوي 2026",
    image: "https://readdy.ai/api/search-image?query=Gulf%20Air%20aircraft%20in%20flight%20blue%20sky%20Bahrain%20airline%20news%20aviation%20direct%20route%20expansion%20luxury%20cabin%20interior&width=1920&height=1080&seq=hero4&orientation=landscape",
    readTime: "3 دقائق",
    date: "19 أبريل 2026",
    author: "منى الشمري",
    views: "21,300",
    tag: "طيران",
  },
];

export const trendingArticles = [
  {
    id: 1,
    category: "طيران",
    title: "طيران الإمارات تُطلق خطاً مباشراً إلى 12 وجهة جديدة في 2026",
    excerpt: "الشركة تُعلن عن توسع كبير في شبكة رحلاتها الدولية وإضافة طائرات A380 المحدّثة",
    image: "https://readdy.ai/api/search-image?query=Emirates%20Airlines%20aircraft%20in%20flight%20above%20clouds%20blue%20sky%2C%20aviation%20news%20expansion%202026%2C%20wide%20body%20plane%20exterior%20photography%20clean%20background&width=800&height=500&seq=trend1&orientation=landscape",
    readTime: "3 دقائق",
    date: "22 أبريل 2026",
    views: "12,400",
    author: "أحمد الزهراني",
  },
  {
    id: 2,
    category: "فنادق",
    title: "افتتاح فندق هيلتون الدوحة الجديد بـ 450 غرفة فاخرة على الكورنيش",
    excerpt: "الفندق يضم أكبر مركز مؤتمرات في قطر وحمامات سباحة لانهائية تطل على الخليج",
    image: "https://readdy.ai/api/search-image?query=New%20luxury%20hotel%20opening%20Doha%20Qatar%20Corniche%20waterfront%20Hilton%20opening%20ceremony%202026%2C%20modern%20architecture&width=400&height=300&seq=trend2&orientation=landscape",
    readTime: "4 دقائق",
    date: "21 أبريل 2026",
    views: "9,800",
    author: "رنا القحطاني",
  },
  {
    id: 3,
    category: "السياحة الثقافية",
    title: "مهرجان العُلا الدولي للفنون يستقطب أكثر من مليون زائر",
    excerpt: "المهرجان شهد مشاركة 240 فناناً من 60 دولة في تجربة ثقافية استثنائية وسط التكوينات الصخرية",
    image: "https://readdy.ai/api/search-image?query=AlUla%20festival%20arts%20culture%20Saudi%20Arabia%20rock%20formations%20lights%20show%20night%20photography%20cultural%20event&width=400&height=300&seq=trend3&orientation=landscape",
    readTime: "5 دقائق",
    date: "20 أبريل 2026",
    views: "8,200",
    author: "فيصل الدوسري",
  },
  {
    id: 4,
    category: "تقنية السفر",
    title: "تطبيقات الذكاء الاصطناعي تُحدث ثورة في تجربة السياح الخليجيين",
    excerpt: "دراسة جديدة: 73% من المسافرين الخليجيين يعتمدون على الذكاء الاصطناعي في تخطيط رحلاتهم",
    image: "https://readdy.ai/api/search-image?query=Traveler%20using%20smartphone%20AI%20travel%20technology%20airport%20modern%20digital%20nomad%20tourism%20news%20report&width=400&height=300&seq=trend4&orientation=landscape",
    readTime: "4 دقائق",
    date: "19 أبريل 2026",
    views: "7,600",
    author: "سامي الحربي",
  },
  {
    id: 5,
    category: "السياحة البيئية",
    title: "الكويت تُطلق أول محمية بحرية متكاملة لدعم السياحة البيئية",
    excerpt: "مشروع تاريخي يُحوّل منطقة جزر البحرين الكويتية إلى وجهة عالمية للغوص وسياحة الطبيعة",
    image: "https://readdy.ai/api/search-image?query=Kuwait%20marine%20reserve%20island%20eco%20tourism%20diving%20clear%20blue%20water%20nature%20conservation%20news&width=400&height=300&seq=trend5&orientation=landscape",
    readTime: "6 دقائق",
    date: "18 أبريل 2026",
    views: "6,900",
    author: "نورة المنصور",
  },
];

export const latestNews = [
  {
    id: 1,
    category: "فنادق",
    title: "ماريوت تفتتح أول فندق من نوعه في شرم الشيخ بتصميم تحت الماء",
    date: "22 أبريل 2026",
    image: "https://readdy.ai/api/search-image?query=Underwater%20hotel%20room%20panoramic%20window%20sea%20view%20luxury%20resort%20Sharm%20el%20Sheikh%20Red%20Sea%20news&width=400&height=280&seq=news1&orientation=landscape",
    readTime: "3 دقائق",
  },
  {
    id: 2,
    category: "طيران",
    title: "الاتحاد للطيران تُعلن عن برنامج ولاء جديد يشمل 45 شريكاً عالمياً",
    date: "22 أبريل 2026",
    image: "https://readdy.ai/api/search-image?query=Etihad%20Airways%20cabin%20crew%20service%20premium%20business%20class%20aviation%20loyalty%20program%20news&width=400&height=280&seq=news2&orientation=landscape",
    readTime: "2 دقائق",
  },
  {
    id: 3,
    category: "مؤتمرات",
    title: "معرض سوق السفر العربي 2026 يكسر الأرقام القياسية بـ 40 ألف زائر",
    date: "21 أبريل 2026",
    image: "https://readdy.ai/api/search-image?query=Arabian%20Travel%20Market%20Dubai%20exhibition%202026%20trade%20fair%20tourism%20conference%20busy%20hall%20visitors&width=400&height=280&seq=news3&orientation=landscape",
    readTime: "4 دقائق",
  },
  {
    id: 4,
    category: "تقارير",
    title: "تقرير: السياحة الداخلية السعودية نمت 34% في الربع الأول من 2026",
    date: "21 أبريل 2026",
    image: "https://readdy.ai/api/search-image?query=Saudi%20Arabia%20domestic%20tourism%20growth%20Asir%20mountains%20Diriyah%20visitors%20graph%20report%202026&width=400&height=280&seq=news4&orientation=landscape",
    readTime: "6 دقائق",
  },
  {
    id: 5,
    category: "عمران سياحي",
    title: "مشروع البحر الأحمر: إنجاز 18 جزيرة سياحية وافتتاح رسمي في 2027",
    date: "20 أبريل 2026",
    image: "https://readdy.ai/api/search-image?query=Red%20Sea%20Project%20Saudi%20Arabia%20island%20resort%20construction%20aerial%20view%20luxury%20development%20news%202026&width=400&height=280&seq=news5&orientation=landscape",
    readTime: "5 دقائق",
  },
  {
    id: 6,
    category: "إحصائيات",
    title: "الأمم المتحدة: السياحة الخليجية ستتجاوز 150 مليار دولار بحلول 2030",
    date: "20 أبريل 2026",
    image: "https://readdy.ai/api/search-image?query=Gulf%20tourism%20economy%20report%20UN%20statistics%202030%20forecast%20data%20visualization%20charts%20growth&width=400&height=280&seq=news6&orientation=landscape",
    readTime: "7 دقائق",
  },
];

export const featuredDestinations = [
  {
    id: 1,
    name: "دبي",
    country: "الإمارات العربية المتحدة",
    articles: 245,
    image: "https://readdy.ai/api/search-image?query=Dubai%20city%20aerial%20view%20night%20skyline%20Burj%20Khalifa%20illuminated%20luxury%20destination%20rich%20vibrant%20colors%20long%20exposure%20photography&width=600&height=800&seq=dest1&orientation=portrait",
  },
  {
    id: 2,
    name: "الرياض",
    country: "المملكة العربية السعودية",
    articles: 187,
    image: "https://readdy.ai/api/search-image?query=Riyadh%20Saudi%20Arabia%20modern%20city%20skyline%20at%20sunset%20Kingdom%20Tower%20futuristic%20urban%20architecture%20travel&width=600&height=800&seq=dest2&orientation=portrait",
  },
  {
    id: 3,
    name: "مسقط",
    country: "سلطنة عُمان",
    articles: 132,
    image: "https://readdy.ai/api/search-image?query=Muscat%20Oman%20coastal%20city%20mountains%20Sultan%20Qaboos%20mosque%20golden%20dome%20blue%20sea%20beautiful%20travel%20destination&width=600&height=800&seq=dest3&orientation=portrait",
  },
  {
    id: 4,
    name: "الدوحة",
    country: "قطر",
    articles: 118,
    image: "https://readdy.ai/api/search-image?query=Doha%20Qatar%20skyline%20corniche%20waterfront%20modern%20towers%20reflection%20in%20water%20at%20blue%20hour%20dusk%20travel&width=600&height=800&seq=dest4&orientation=portrait",
  },
  {
    id: 5,
    name: "المنامة",
    country: "البحرين",
    articles: 94,
    image: "https://readdy.ai/api/search-image?query=Manama%20Bahrain%20city%20skyline%20waterfront%20modern%20architecture%20sunset%20golden%20hour%20travel%20Middle%20East&width=600&height=800&seq=dest5&orientation=portrait",
  },
  {
    id: 6,
    name: "الكويت",
    country: "دولة الكويت",
    articles: 86,
    image: "https://readdy.ai/api/search-image?query=Kuwait%20City%20waterfront%20skyline%20Liberation%20Tower%20at%20night%20modern%20architecture%20tourism%20destination&width=600&height=800&seq=dest6&orientation=portrait",
  },
];

export const hotelNewsArticles = [
  {
    id: 1,
    title: "برج العرب يحصل على تصنيف سبع نجوم للمرة الثالثة عشرة على التوالي",
    location: "دبي، الإمارات",
    category: "فنادق",
    badge: "أخبار حصرية",
    image: "https://readdy.ai/api/search-image?query=Burj%20Al%20Arab%20luxury%20hotel%20Dubai%20sail%20shape%20iconic%20architecture%20blue%20sea%20exterior%20photography%20iconic%20landmark&width=600&height=400&seq=hotelnews1&orientation=landscape",
    date: "22 أبريل 2026",
    readTime: "3 دقائق",
  },
  {
    id: 2,
    title: "منتجع أنانتارا أبوظبي يُطلق برنامج رفاهية جديداً مستوحى من التراث الإماراتي",
    location: "أبوظبي، الإمارات",
    category: "منتجعات",
    badge: "تقارير",
    image: "https://readdy.ai/api/search-image?query=Anantara%20Abu%20Dhabi%20resort%20luxury%20pool%20traditional%20Arabic%20architecture%20wellness%20program%20travel%20news&width=600&height=400&seq=hotelnews2&orientation=landscape",
    date: "21 أبريل 2026",
    readTime: "4 دقائق",
  },
  {
    id: 3,
    title: "فنادق فورسيزونز تُدشّن أضخم توسع لها في منطقة الشرق الأوسط بـ 7 فنادق جديدة",
    location: "المنطقة الخليجية",
    category: "افتتاحيات",
    badge: "عاجل",
    image: "https://readdy.ai/api/search-image?query=Four%20Seasons%20hotel%20opening%20Middle%20East%20luxury%20hospitality%20expansion%20news%202026%20grand%20lobby%20interior&width=600&height=400&seq=hotelnews3&orientation=landscape",
    date: "20 أبريل 2026",
    readTime: "5 دقائق",
  },
  {
    id: 4,
    title: "فندق رافلز الدوحة يستضيف القمة العالمية للضيافة الفاخرة 2026",
    location: "الدوحة، قطر",
    category: "فعاليات",
    badge: "تغطية",
    image: "https://readdy.ai/api/search-image?query=Raffles%20hotel%20Doha%20Qatar%20luxury%20hospitality%20summit%20conference%20event%20grand%20ballroom%20elegant&width=600&height=400&seq=hotelnews4&orientation=landscape",
    date: "19 أبريل 2026",
    readTime: "6 دقائق",
  },
];

export const opinionArticles = [
  {
    id: 1,
    title: "لماذا ستكون السياحة البيئية أكبر ترند في الخليج خلال السنوات القادمة؟",
    author: "د. خالد المهنا",
    authorTitle: "خبير السياحة المستدامة",
    image: "https://readdy.ai/api/search-image?query=eco%20tourism%20sustainability%20Gulf%20region%20nature%20conservation%20writer%20journalist%20opinion%20column%20portrait%20professional&width=200&height=200&seq=op1&orientation=squarish",
    date: "22 أبريل 2026",
    readTime: "8 دقائق",
  },
  {
    id: 2,
    title: "رؤية 2030 والسياحة: أين نقف الآن وإلى أين نتجه؟",
    author: "رهف العتيبي",
    authorTitle: "محللة اقتصادية",
    image: "https://readdy.ai/api/search-image?query=Saudi%20Vision%202030%20tourism%20analysis%20female%20journalist%20writer%20professional%20portrait%20modern%20office&width=200&height=200&seq=op2&orientation=squarish",
    date: "21 أبريل 2026",
    readTime: "10 دقائق",
  },
  {
    id: 3,
    title: "الذكاء الاصطناعي والسياحة: فرصة أم تهديد للعنصر البشري؟",
    author: "م. طارق النجار",
    authorTitle: "مستشار تقنية السياحة",
    image: "https://readdy.ai/api/search-image?query=AI%20technology%20tourism%20writer%20male%20analyst%20professional%20portrait%20office%20modern%20background&width=200&height=200&seq=op3&orientation=squarish",
    date: "20 أبريل 2026",
    readTime: "7 دقائق",
  },
];

export const newsCategories = [
  { id: 1, name: "الطيران والمطارات", icon: "ri-plane-line", count: 145 },
  { id: 2, name: "الفنادق والمنتجعات", icon: "ri-hotel-line", count: 213 },
  { id: 3, name: "الترفيه العائلي", icon: "ri-emotion-happy-line", count: 98 },
  { id: 4, name: "الثقافة والفنون", icon: "ri-ancient-pavilion-line", count: 76 },
  { id: 5, name: "السياحة الرياضية", icon: "ri-trophy-line", count: 87 },
  { id: 6, name: "الوجهات السياحية", icon: "ri-map-pin-line", count: 324 },
  { id: 7, name: "المعالم السياحية", icon: "ri-ancient-gate-line", count: 156 },
  { id: 8, name: "المعارض والفعاليات", icon: "ri-calendar-event-line", count: 112 },
  { id: 9, name: "تقنية السفر", icon: "ri-smartphone-line", count: 65 },
  { id: 10, name: "العقارات السياحية", icon: "ri-building-2-line", count: 89 },
  { id: 11, name: "تقارير وإحصائيات", icon: "ri-bar-chart-2-line", count: 178 },
];
